// extracted by mini-css-extract-plugin
module.exports = {"expandBtn":"PatientNames_expandBtn__115zy"};